<ng-template cellTemplate let-dataItem="dataItem">
    <div class="layout" (click)="$event['ignoreClickOutside'] = true">
        <fui-color-pair-view class="color-pair-view"
                             [backgroundColor]="dataItem | property: backgroundColorField"
                             [foregroundColor]="dataItem | property: foregroundColorField"
                             [propagateClick]="true"
                             (onBackgroundClick)="backgroundClicked()"
                             (onForegroundClick)="foregroundClicked()">
        </fui-color-pair-view>
        <div class="placeholder" *ngIf="!(dataItem | property: backgroundColorField) && !(dataItem | property: foregroundColorField)">
            {{getPlaceholder(dataItem) | translate}}
        </div>
        <div class="canvas" *ngIf="(dataItem | property: backgroundColorField) || (dataItem | property: foregroundColorField)"
             [ngClass]="{'checkered': !!(dataItem | property: backgroundColorField)}">
            <div class="color-pair-display"
                 [style.background-color]="dataItem | property: backgroundColorField">
                <span [style.color]="dataItem | property: foregroundColorField" class="color-pair-display-text">
                    {{dataItem | property: backgroundColorField}} {{dataItem | property: foregroundColorField}}
                </span>
            </div>
        </div>
    </div>
</ng-template>
<ng-template editTemplate
             let-dataItem="dataItem"
             let-columnIndex="columnIndex"
             let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex" [editControl]="editControl">
    </wbo-edit-grid-cell-activator>
    {{setupFormGroup(formGroup, dataItem)}}
    <div class="color-pair-edit">
        <fui-color-pair-control #editControl (focussed$)="columnFocusHandler(columnIndex)"
                                [readOnly]="cellDisabled(formGroup, dataItem)"
                                [placeholder]="getPlaceholder(dataItem)"
                                [attr.id]="elementId"
                                [value]="getColorPair(formGroup)"
                                (valueChange)="setColorPair(formGroup, $event)"
                                [showClearIcon]="canShowClearButton(dataItem)" (onClear)="clear(formGroup)"
                                [(backgroundSelected)]="backgroundSelected"
                                [backgroundEditable]="true" [foregroundEditable]="true"
                                [allowBackgroundAlpha]="allowAlpha" [allowForegroundAlpha]="allowAlpha">
        </fui-color-pair-control>
    </div>
</ng-template>
